export enum GoalTimeframe {
  NEXT_FEW_DAYS = "NEXT_FEW_DAYS",
  NEXT_30_DAYS = "NEXT_30_DAYS",
  NEXT_60_DAYS = "NEXT_60_DAYS",
  LONGER_TIMELINE = "LONGER_TIMELINE"
}
